import { useEffect, useState } from "react";
import { MapPin, CheckCircle2, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import { publicApi, errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", contact: "", body: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [info, setInfo] = useState({});

  useEffect(() => {
    publicApi.get("/public/settings").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await publicApi.post("/public/contact", form);
      setSent(true);
      setForm({ name: "", contact: "", body: "" });
    } catch (er) {
      toast.error(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <p className="eyebrow text-[#E07A5F]">İletişim</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-[#1B4332] mt-2">Bize ulaşın</h1>
      <div className="grid lg:grid-cols-2 gap-6 mt-10">
        <div className="bg-white rounded-[2rem] border border-black/5 overflow-hidden flex flex-col">
          <div className="p-8 space-y-3">
            <p className="flex gap-3 text-slate-700 font-medium"><MapPin className="text-[#1B4332] shrink-0" /> Büğdüz Mah. 156. Sok. No:17, Başkent Sitesi, Akyurt / Ankara</p>
            {info.contact_phone && <p className="flex gap-3 text-slate-700" data-testid="contact-phone"><Phone className="text-[#1B4332]" /> {info.contact_phone}</p>}
            {info.contact_email && <p className="flex gap-3 text-slate-700" data-testid="contact-email"><Mail className="text-[#1B4332]" /> {info.contact_email}</p>}
          </div>
          <iframe title="Başkent Sitesi Harita" src="https://maps.google.com/maps?q=40.107994,33.036933&hl=tr&z=15&output=embed" className="w-full h-80 border-0 flex-1" loading="lazy" />
        </div>
        <div className="bg-white rounded-[2rem] border border-black/5 p-8">
          <h2 className="font-display text-xl font-bold text-slate-800 mb-6">Mesaj gönderin</h2>
          {sent ? (
            <div className="text-center py-12" data-testid="contact-success">
              <CheckCircle2 size={48} className="mx-auto text-[#1B4332]" />
              <p className="font-bold mt-4">Mesajınız alındı</p>
              <button onClick={() => setSent(false)} className="mt-4 text-sm font-bold text-[#E07A5F] underline" data-testid="contact-new-btn">Yeni mesaj</button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <Input required placeholder="Adınız Soyadınız" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-12 rounded-xl" data-testid="contact-name-input" />
              <Input required placeholder="E-posta veya telefon" value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} className="h-12 rounded-xl" data-testid="contact-info-input" />
              <Textarea required rows={5} placeholder="Mesajınız" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="rounded-xl" data-testid="contact-body-input" />
              <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold" data-testid="contact-submit-btn">
                {busy ? "Gönderiliyor..." : "Gönder"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
